function agregarClaseCuandoCargado() {
    var targetNode = document.querySelector('.container-reviews-stars__collection > div[data-oke-star-rating]');
    $(targetNode).each(function( index ) {
      var ClassOkendo = $(this).find('.oke-sr-rating').text();
      $(this).parents('.container-reviews-stars__collection').addClass('reviews-okendo-collection-');
    });
}

var observerConfig = { 
    childList: true, 
    subtree: true 
};

var observer = new MutationObserver(agregarClaseCuandoCargado);
observer.observe(document.documentElement, observerConfig);
agregarClaseCuandoCargado();
